import BackButton from '@portal/features/navigation/BackButton'
import { Header } from '@portal/features/navigation/Header'
import { GroupTitle } from '@portal/features/titles'
import { WhatIfIncomeSubmission } from '@portal/features/whatif/WhatIfIncomeSubmission'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => (
  <>
    <Header.Left>
      <BackButton to="/whatif" />
    </Header.Left>
    <Header.Center>
      <GroupTitle />
    </Header.Center>
    <WhatIfIncomeSubmission />
  </>
)

export const Route = createFileRoute(
  '/_app/whatif_/income-submission/$topicId'
)({
  component: RouteComponent,
})
